import React, { useEffect } from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { CustomTextBox } from "components/CustomComponents";
import { CustomButton } from "components/CustomComponents/CustomButton";
import { customAPI } from "services/utils/CustomAPI";
import { showToast } from "services/utils/Status";
import { useSelector } from "react-redux";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";

import {
  doubleArrowStyle,
  themes,
  parentBoxStyle,
  childBoxStyleWithColor,
  infoStyle,
  toAlignEnd,
  childBoxStyle,
} from "services/constants";

export const EditEmployeeGroup = ({
  onClose,
  reCallApi,
  editEmpGrpDetails,
  setGetId,
  setHandleLoader,
}) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain } = useSelector((state) => state.tokenReducer);

  const {
    setValue,
    handleSubmit,
    register,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      group_name: "",
    },
  });

  useEffect(() => {
    if (!editEmpGrpDetails) return;
    setValue("group_name", editEmpGrpDetails?.group_name ?? "");
  }, [editEmpGrpDetails, setValue]);

  const handleGroupName = (event) => {
    setValue("group_name", event.target.value);
  };

  const onSubmit = async (data) => {
    setValue("button_loader", true);

    const payload = {
      group_id: editEmpGrpDetails?.group_id,
      group_name: data.group_name,
    };

    const id = editEmpGrpDetails?.group_id;

    if (!id) {
      setValue("button_loader", false);
      showToast("error", "Missing Employee group id. Cannot update.");
      return;
    }

    try {
      const url = `${domain}employee-group/?company_id=${requestCompanyId}`;
      const response = await customAPI(url, "PUT", payload);

      if (response.ok) {
        showToast(
          "success",
          response?.responseDetails?.message ??
            "Employee group updated successfully"
        );
        setValue("button_loader", false);
        onClose();
        setHandleLoader(true);
        reCallApi(true);
        if (setGetId) setGetId(id);
      } else {
        setValue("button_loader", false);
        showToast(
          "error",
          response?.message ?? "Failed to update Employee Group"
        );
      }
    } catch (err) {
      console.error('[Editemployeegroup] operation failed:', err);
      setValue("button_loader", false);
      showToast("error", err?.message ?? "Something went wrong");
    }
  };

  return (
    <Box sx={parentBoxStyle}>
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box sx={childBoxStyleWithColor}>
          <Box sx={{ ml: 1 }}>
            <IconButton onClick={onClose} sx={doubleArrowStyle}>
              <DoubleArrow />
            </IconButton>
          </Box>

          <Box sx={{ ml: 2.2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Edit Employee Group
            </Typography>
            <Typography {...infoStyle}>Edit Employee Group.</Typography>
          </Box>
        </Box>
      </Paper>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box sx={childBoxStyle}>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Group Name</Typography>
              <CustomTextBox
                rules={{
                  ...register("group_name", {
                    required: "Employee group name is required",
                    minLength: {
                      value: 3,
                      message: "Minium length is 3 characters",
                    },
                    maxLength: {
                      value: 100,
                      message: "Maximum length is 100 characters",
                    },
                    validate: {
                      atleastOneCharacterWithSpaceReg: (value) => {
                        if (
                          atleastOneCharacterWithSpace.test(value) ||
                          value === ""
                        ) {
                          return true;
                        } else {
                          return "Atleast one alphabet required";
                        }
                      },
                    },
                  }),
                }}
                selectedValue={watch("group_name")}
                updateDataFunction={handleGroupName}
                placeHolder="Enter employee group name"
                errorMessage={
                  errors?.group_name?.message ? errors?.group_name?.message : ""
                }
                textBoxError={errors?.group_name ? true : false}
              />
            </Box>

            <Box sx={toAlignEnd}>
              <CustomButton
                actionFuntion={handleSubmit(onSubmit)}
                actionName="Update"
                typeName="submit"
                disableAction={watch("button_loader")}
              />
            </Box>
          </Box>
        </Box>
      </form>
    </Box>
  );
};

export default EditEmployeeGroup;
